export const SHIPPING_ADDRESS_ID = "shipping-address";
export const SHIPPING_METHOD_ID = "shipping-method";
export const SHIPPING_PAYMENTS_ID = "shipping-payments";
export const BILAN_SECTION_ID = "section-bilan";
